import { Component, OnInit } from '@angular/core';
import { AppSingle } from '../../app-single';
import { DependentMeepServerModel } from '../../models/dependent.model';
import { ActivatedRoute } from '@angular/router';
import { DependentService } from '../../services/dependent.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { InputModel } from '../input/input.model';
import { RequiredModel } from '../input/rules/implementations/required.model';
import { CurrencyModel } from '../input/rules/implementations/currency.model';
import { MaskHelper } from '../../helpers/mask';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.less']
})
export class NotificationsComponent extends AppSingle implements OnInit {

  dependent: DependentMeepServerModel = new DependentMeepServerModel();
  minBalance: number;
  hasMinBalance: boolean;
  minBalanceToShow;
  minBalanceInputModel;

  constructor(route: ActivatedRoute, private dependentsService: DependentService, private notificationService: NotificationService) {
    super(route);
    this.minBalanceInputModel = new InputModel(false, false, 'tel', 'R$ 0,00', [new RequiredModel()], new CurrencyModel());
  }

  private setMinBalance(minBalance, msg: string) {
    this.dependentsService.updateMinBalance(this.dependent.Tag, minBalance)
    .then(() => {
      this.notificationService.showSuccessNotification(msg);
    })
    .catch((err) => {
      this.notificationService.showErrorNotification(err.message);
    });
  }

  ngOnInit() {
    this.dependentsService.getFromMeepServer(this.id)
      .then((_dependent: DependentMeepServerModel) => {
        this.dependent = _dependent;
        if (_dependent.SaldoMinimo) {
          this.minBalanceToShow = _dependent.SaldoMinimo.toFixed(2);
          this.hasMinBalance = true;
        } else {
          this.dependent.SaldoMinimo = 0;
          this.minBalanceToShow = 0;
          this.hasMinBalance = false;
        }
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  disableMinBalance(event) {
    if (!event.checked) {
      this.notificationService.showQuestionNotification('Você deseja remover a notificação de saldo mínimo?')
      .then((result) => {
        if (result.value) {
          this.setMinBalance(null, 'Notificação de saldo mínimo removido com sucesso!');
        } else {
          this.hasMinBalance = true;
        }
      });
    } else {
      this.dependent.SaldoMinimo = 0;
      this.minBalanceToShow = 0;
      this.hasMinBalance = true;
    }
  }

  enableMinBalance() {
    if (this.minBalanceToShow && MaskHelper._removeCurrency(this.minBalanceToShow) > 0) {
      const formatedValue = MaskHelper._removeCurrency(this.minBalanceToShow);
      this.setMinBalance(formatedValue, 'Notificação de saldo mínimo adicionado com sucesso!');
    } else {
      this.notificationService.showErrorNotification('Preencha um valor para o saldo mínimo!');
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/notifications/notifications.component.ts